import { render } from "./SettingWorkshift.vue?vue&type=template&id=2d2f0b39&scoped=true"
import script from "./SettingWorkshift.vue?vue&type=script&lang=js"
export * from "./SettingWorkshift.vue?vue&type=script&lang=js"

import "./SettingWorkshift.vue?vue&type=style&index=0&id=2d2f0b39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2f0b39"]])

export default __exports__